import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { GetSportsListApi } from '../redux/actions/event-management/GetSportsListAction';

const Filters = ({
    searchInput, setSearchInput,
    dateInput, setDateInput,
    statusInput, setStatusInput,
    eventTypeInput, setEventTypeInput,
    sportInput, setSportInput,
    locationInput, setLocationInput,
    setSearch, setDate, setStatus,
    setEventType, setSport, setLocation,
    handleSearchClick
}) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const isUserManagement = location.pathname === '/admin-dashboard/user-management';
    const isEventManagement = location.pathname === '/admin-dashboard/event-and-challenge-management';
    const isContentManagement = location.pathname === '/admin-dashboard/content-management';
    const filterHandlersRef = useRef({});
    const didApplyInitialFiltersRef = useRef(false);

    const { response: sportsListResponse, error: sportsListError } = useSelector((state) => state.getSportsList)

    const getStatusOptions = () => {
        if (isUserManagement) {
            return [
                { value: '', label: 'All status' },
                { value: 'active', label: 'Active' },
                { value: 'banned', label: 'Banned' }
            ];
        } else if (isEventManagement) {
            return [
                { value: '', label: 'All status' },
                { value: 'draft', label: 'Draft' },
                { value: 'upcoming', label: 'Upcoming' },
                { value: 'past', label: 'Past' },
                { value: 'ongoing', label: 'Ongoing' }
            ];
        } else {
            return [
                { value: '', label: 'All status' },
                { value: 'Open', label: 'Open' },
                { value: 'Reviewed', label: 'Reviewed' },
                { value: 'Actioned', label: 'Actioned' }
            ];
        }
    };
    // const [searchInput, setSearchInput] = useState('');
    // const [dateInput, setDateInput] = useState('');
    // const [statusInput, setStatusInput] = useState('');

    useEffect(() => {
        dispatch(GetSportsListApi());
    }, [dispatch])

    useEffect(() => {
        filterHandlersRef.current = {
            handleSearchClick,
            setDate,
            setEventType,
            setLocation,
            setSearch,
            setSport,
            setStatus,
        };
    }, [handleSearchClick, setDate, setEventType, setLocation, setSearch, setSport, setStatus]);

    useEffect(() => {
        if (!didApplyInitialFiltersRef.current) {
            didApplyInitialFiltersRef.current = true;
            return;
        }

        const timer = setTimeout(() => {
            const {
                handleSearchClick: applySearch,
                setDate: applyDate,
                setEventType: applyEventType,
                setLocation: applyLocation,
                setSearch: applySearchValue,
                setSport: applySport,
                setStatus: applyStatus,
            } = filterHandlersRef.current;

            if (isUserManagement) {
                applySearchValue(searchInput);
                applyDate(dateInput);
                applyStatus(statusInput);
                applySearch?.(searchInput, dateInput, statusInput);
            } else if (isEventManagement) {
                applySearchValue(searchInput);
                applyStatus(statusInput);
                applyEventType(eventTypeInput);
                applySport(sportInput);
                applyLocation(locationInput);
                applySearch?.(searchInput, statusInput, locationInput, sportInput, eventTypeInput);
            } else {
                applySearchValue(searchInput);
                applyDate(dateInput);
                applyStatus(statusInput);
                applySearch?.(searchInput, dateInput, statusInput);
            }
        }, 350);

        return () => clearTimeout(timer);
    }, [searchInput, dateInput, statusInput, eventTypeInput, sportInput, locationInput, isUserManagement, isEventManagement]);


    return (
        <div className='col-12'>
            <div className='top_filter_block hstack align-items-end flex-wrap gap-3'>
                <div className='form-group'>
                    <label className='fs-12 fw-semibold mb-1'>Search</label>
                    <div className='input-field'>
                        <input type='search' className='form-control' placeholder={location.pathname === '/admin-dashboard/user-management' ? 'Enter Username , Email' : 'Enter Username , keywords , hashtag'} value={searchInput} onChange={(e) => {
                            const value = e.target.value;
                            if (value.length === 1 && value === ' ') return;
                            setSearchInput(value);
                        }} />
                    </div>
                </div>
                {/* <div className='form-group'>
                    <label className='fs-12 fw-semibold mb-1'>Search Email</label>
                    <div className='input-field'>
                        <input type='search' className='form-control' placeholder='Enter Email' />
                    </div>
                </div> */}
                {!isEventManagement && (
                    <div className='form-group'>
                        <label className='fs-12 fw-semibold mb-1'>{isContentManagement ? 'Report Date' : 'Registration Date'}</label>
                        <div className='input-field'>
                            <input type='date' className='form-control' value={dateInput} onChange={(e) => {
                                setDateInput(e.target.value);
                            }} />
                        </div>
                    </div>
                )}

                <div className='form-group'>
                    <label className='fs-12 fw-semibold mb-1'>Status</label>
                    <div className='input-field'>
                        <select className='form-select' value={statusInput}
                            onChange={(e) => setStatusInput(e.target.value)}>
                            {
                                getStatusOptions().map(({ value, label }, index) => (
                                    <option key={index} value={value}>
                                        {label}
                                    </option>
                                ))
                            }
                        </select>
                    </div>
                </div>
                {isEventManagement && (
                    <>
                        <div className="form-group">
                            <label className="fs-12 fw-semibold mb-1">Type</label>
                            <div className="input-field">
                                <select className="form-select" value={eventTypeInput}
                                    onChange={(e) => setEventTypeInput(e.target.value)}>
                                    <option value="">All Type</option>
                                    <option value="event">Event</option>
                                    <option value="challenge">Challenge</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="fs-12 fw-semibold mb-1">Sport</label>
                            <div className="input-field">
                                {/* <select className="form-select" value={sportInput}
                                    onChange={(e) => setSportInput(e.target.value)}>
                                    <option value="">All Sport</option>
                                    <option value="football">Football</option>
                                    <option value="basketball">Basketball</option>
                                    <option value="tennis">Tennis</option>
                                </select> */}
                                <select className="form-select" value={sportInput}
                                    onChange={(e) => setSportInput(e.target.value)}>
                                    <option value="">All Sport</option>
                                    {sportsListResponse && sportsListResponse?.data?.length > 0 ? (
                                        sportsListResponse?.data?.map((sport, index) => (
                                            <option key={index} value={sport.id}>
                                                {sport.name}
                                            </option>
                                        ))
                                    ) : sportsListError ? (
                                        <option disabled>No sports available</option>
                                    ) : <option disabled>No sports available</option>}
                                </select>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="fs-12 fw-semibold mb-1">Location</label>
                            <div className="input-field">
                                <input class="form-control" placeholder="City, venue" type="text" value={locationInput}
                                    onChange={(e) => setLocationInput(e.target.value)} />
                            </div>
                        </div>
                    </>
                )}
            </div >
        </div >
    )
}

export default Filters
